<template>
    <div>
        <v-layout align-center>
            <v-flex class="ml-3">
                <div
                    v-if="errorLocation"
                    v-t="`error.${errorLocation}`"
                    class="text-danger small"
                ></div>
            </v-flex>
            <v-flex class="text-end">
                <v-btn
                    @click="watchLocation"
                    type="button"
                    :loading="gpsLoading"
                    rounded
                    dark
                    :color="
                        positionAccuracy < 20 ? 'green' : positionAccuracy > 50 ? 'red' : 'orange'
                    "
                >
                    <span v-if="positionAccuracy">{{ positionAccuracy }} {{ $t("m") }}</span>
                    <v-icon :right="Boolean(positionAccuracy)">gps_fixed</v-icon>
                </v-btn>
                <v-btn
                    @click="lockedMarker = !lockedMarker"
                    type="button"
                    icon
                    large
                    v-if="!readonly"
                >
                    <v-icon v-if="lockedMarker">lock</v-icon>
                    <v-icon v-else>lock_open</v-icon>
                </v-btn>
                <v-btn @click="openGoogleMap" target="_blank" icon large>
                    <img src="@/assets/gmlogo.png" alt width="34px" />
                </v-btn>
            </v-flex>
        </v-layout>
        <GmapMap
            :style="{ height, width }"
            :zoom="zoom"
            :center="{ lat: 46.723807, lng: 8.038344 }"
            ref="map"
            @center_changed="drag"
            :options="{
                tilt: 0,
                disableDefaultUI: true,
                zoomControl: true,
                maxZoom: 20,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                mapTypeId: 'hybrid',
                gestureHandling: 'auto',
            }"
        >
            <GmapMarker
                ref="meMarker"
                :position="gpsPosition"
                v-if="gpsPosition"
                :icon="{
                    url: require('@/assets/geomarker.png'),
                    size: new google.maps.Size(55, 55),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 17),
                    scaledSize: new google.maps.Size(34, 34),
                }"
            />
        </GmapMap>
    </div>
</template>

<script>
import GeoLocation from "@/utils/GeoLocation"
import { gmapApi } from "vue2-google-maps"
import debounce from "lodash.debounce"
require("@/assets/geomarker.png")
export default {
    data() {
        return {
            geoLocation: new GeoLocation(),
            gpsLoading: false,
            positionAccuracy: null,
            lockedMarker: false,
            gpsPosition: null,
            marker: null,
            zoom: 18,
            place: null,
            center: { lat: 46.228, lng: 7.356484 },
            errorLocation: false,
        }
    },
    props: {
        width: { type: String, default: "100%" },
        height: { type: String, default: "300px" },
        readonly: { type: Boolean, default: false },
        lockedPosition: { type: Boolean, default: false },
        location: {
            type: Object,
            default() {
                return null
            },
        },
    },
    async mounted() {
        this.lockedMarker = this.lockedPosition
        if (this.location && this.location.lng) {
            this.zoom = 20
            this.center = {
                lng: parseFloat(this.location.lng),
                lat: parseFloat(this.location.lat),
            }
        }
        this.setValue({ lng: this.center.lng, lat: this.center.lat })
        this.$refs.map.$mapPromise.then(map => {
            map.setCenter(this.center)
            this.marker = new google.maps.Marker({
                map: map,
                position: this.center,
            })
        })
    },
    deactivated() {
        this.gpsPosition = null
        this.positionAccuracy = null
        this.geoLocation.stopWatch()
    },
    beforeDestroy() {
        this.gpsPosition = null
        this.positionAccuracy = null
        this.geoLocation.stopWatch()
    },
    methods: {
        setPlace(place) {
            this.place = place
            this.usePlace()
        },
        usePlace(place) {
            if (this.place) {
                const location = {
                    lat: this.place.geometry.location.lat(),
                    lng: this.place.geometry.location.lng(),
                }
                this.setCenter(location)
                this.place = null
            }
        },
        setValue: debounce(function(v) {
            this.$emit("update:location", v)
        }, 200),
        openGoogleMap() {
            const position = this.marker.getPosition()
            window.open(
                `https://www.google.com/maps/search/?api=1&query=${position.lat()},${position.lng()}`,
                "_blank"
            )
        },
        drag(e) {
            this.changePosition({ lat: e.lat(), lng: e.lng() })
        },
        changePosition(location) {
            if (!this.lockedMarker && this.marker && !this.readonly) {
                this.marker.setPosition(new google.maps.LatLng(location.lat, location.lng))
                this.setValue({ lat: location.lat, lng: location.lng })
            }
        },
        setCenter(location) {
            this.changePosition(location)
            this.$refs.map.$mapPromise.then(map => {
                map.setCenter(location)
            })
        },
        watchLocation() {
            if (this.gpsPosition) {
                this.$refs.map.$mapPromise.then(map => {
                    map.setCenter(this.gpsPosition)
                })
                this.changePosition(this.gpsPosition)
                return
            }
            this.gpsLoading = true
            this.errorLocation = false
            this.geoLocation.watch(
                position => {
                    this.positionAccuracy = position.coords.accuracy.toFixed(2)
                    this.gpsLoading = false
                    const p = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }

                    if (!this.gpsPosition) {
                        this.$refs.map.$mapPromise.then(map => {
                            map.setCenter(p)
                        })
                        this.changePosition(p)
                    }
                    this.gpsPosition = p
                },
                e => {
                    console.error(e)
                    this.errorLocation = true
                }
            )
        },
    },
    computed: {
        google: gmapApi,
    },
}
</script>
